export const subtitle = 'Learn about our unique generosity programs';
